var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackfulllogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 32,
    viewBox: "0 0 118 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1704C0 9.86024 0 7.20518 1.03342 5.17698C1.94244 3.39292 3.39292 1.94244 5.17698 1.03342C7.20518 0 9.86024 0 15.1704 0H16.8296C22.1398 0 24.7948 0 26.823 1.03342C28.6071 1.94244 30.0576 3.39292 30.9666 5.17698C32 7.20518 32 9.86024 32 15.1704V16.8296C32 22.1398 32 24.7948 30.9666 26.823C30.0576 28.6071 28.6071 30.0576 26.823 30.9666C24.7948 32 22.1398 32 16.8296 32H15.1704C9.86024 32 7.20518 32 5.17698 30.9666C3.39292 30.0576 1.94244 28.6071 1.03342 26.823C0 24.7948 0 22.1398 0 16.8296V15.1704Z",
    fill: "#0F0C18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62964 19.5317V12.6809H11.3914V19.5317H9.62964Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5205 19.5317V12.6809H22.2823V19.5317H20.5205Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3133 19.5317L13.3133 7.11133L15.0751 7.11133L15.0751 19.5317H13.3133Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8368 24.817L16.8368 12.6809H18.5986V24.817H16.8368Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.4 6.65972C112.4 5.14355 113.556 4 115.073 4C116.602 4 117.758 5.14355 117.758 6.64687C117.758 8.1502 116.602 9.2809 115.073 9.2809C113.556 9.2809 112.4 8.1502 112.4 6.65972ZM117.18 6.64687C117.18 5.41338 116.293 4.51396 115.073 4.51396C113.865 4.51396 112.978 5.41338 112.978 6.65972C112.978 7.88037 113.865 8.76694 115.073 8.76694C116.293 8.76694 117.18 7.86752 117.18 6.64687ZM114.07 8.9134V5.5128H115.188C115.882 5.5128 116.319 5.88541 116.319 6.43792C116.319 6.86193 116.062 7.1703 115.638 7.28594L116.651 8.68663H116.021L115.085 7.40158H114.636V8.9134H114.07ZM115.163 5.9882H114.636V6.92617H115.163C115.484 6.92617 115.728 6.74629 115.728 6.43792C115.728 6.14239 115.497 5.9882 115.163 5.9882Z",
    fill: "#0F0C18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4 19C63.7431 19 62.4 17.6568 62.4 16C62.4 14.3431 63.7431 13 65.4 13C67.0569 13 68.4 14.3431 68.4 16C68.4 17.6568 67.0569 19 65.4 19ZM65.4 21C62.6386 21 60.4 18.7614 60.4 16C60.4 13.2386 62.6386 11 65.4 11C68.1614 11 70.4 13.2386 70.4 16C70.4 18.7614 68.1614 21 65.4 21Z",
    fill: "#0F0C18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7 18.8C89.2088 18.8 88 17.5912 88 16.1C88 14.6088 89.2088 13.4 90.7 13.4C92.1912 13.4 93.4 14.6088 93.4 16.1C93.4 17.5912 92.1912 18.8 90.7 18.8ZM90.7 20.8C88.1043 20.8 86 18.6957 86 16.1C86 13.5043 88.1043 11.4 90.7 11.4C91.7943 11.4 92.8012 11.774 93.6 12.4011C94.696 13.2615 95.4 14.5985 95.4 16.1C95.4 17.6014 94.696 18.9384 93.6 19.7989C92.8012 20.426 91.7943 20.8 90.7 20.8Z",
    fill: "#0F0C18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.938 15.0588H105.58C105.985 13.9731 107.032 13.2 108.259 13.2C109.486 13.2 110.532 13.9731 110.938 15.0588ZM105.545 17.0588C105.91 18.2709 106.953 19.2 108.541 19.2C109.618 19.2 110.386 18.8384 110.883 18.4881C111.135 18.3109 111.319 18.1357 111.435 18.0102C111.493 17.9478 111.534 17.8986 111.557 17.869C111.569 17.8542 111.576 17.8444 111.579 17.8405C111.581 17.8385 111.581 17.838 111.58 17.8391L111.578 17.8419L111.577 17.8442L111.576 17.8455L111.575 17.8463C111.575 17.8467 111.575 17.8471 112.4 18.4118C113.225 18.9764 113.225 18.9769 113.225 18.9773L113.224 18.9781L113.223 18.98L113.22 18.9843L113.213 18.9947C113.207 19.0025 113.2 19.0121 113.192 19.0232C113.176 19.0455 113.154 19.0741 113.127 19.1082C113.073 19.1764 112.998 19.2669 112.9 19.3721C112.705 19.5819 112.418 19.8538 112.034 20.1237C111.262 20.6675 110.1 21.2 108.541 21.2C105.275 21.2 103.4 18.6601 103.4 16.0588C103.4 13.3754 105.575 11.2 108.259 11.2C110.942 11.2 113.118 13.3754 113.118 16.0588V17.0588H105.545Z",
    fill: "#0F0C18"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 19C44.6569 19 46 17.6568 46 16C46 14.3431 44.6569 13 43 13C41.3431 13 40 14.3431 40 16C40 17.6568 41.3431 19 43 19ZM43 21C45.7614 21 48 18.7614 48 16C48 13.2386 45.7614 11 43 11C40.2386 11 38 13.2386 38 16C38 18.7614 40.2386 21 43 21Z",
    fill: "#0F0C18"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 16V7.8H48V16H46Z",
    fill: "#0F0C18"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8 7.8H98.8V15C98.8 15.7592 98.8005 16.2785 98.8281 16.6828C98.8551 17.0782 98.9046 17.29 98.9675 17.4419C99.1908 17.981 99.619 18.4092 100.158 18.6325C100.31 18.6954 100.522 18.7449 100.917 18.7719C101.321 18.7995 101.841 18.8 102.6 18.8V20.8H102.565C101.849 20.8 101.262 20.8 100.781 20.7672C100.284 20.7333 99.8289 20.661 99.3927 20.4803C98.3636 20.054 97.546 19.2364 97.1197 18.2073C96.939 17.7711 96.8667 17.3161 96.8328 16.819C96.8 16.3385 96.8 15.7507 96.8 15.0346V7.8Z",
    fill: "#0F0C18"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8 11.6H101.5V13.6H97.8V11.6Z",
    fill: "#0F0C18"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4 16V7.8H60.4V16H62.4Z",
    fill: "#0F0C18"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2 15.8V11.6H51.2V15.8C51.2 17.4568 52.5431 18.8 54.2 18.8C55.8569 18.8 57.2 17.4568 57.2 15.8V11.6H59.2V15.8C59.2 18.5614 56.9614 20.8 54.2 20.8C51.4386 20.8 49.2 18.5614 49.2 15.8Z",
    fill: "#0F0C18"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6 15.6667V20.2H73.6V15.6667C73.6 14.4148 74.6148 13.4 75.8667 13.4C76.603 13.4 77.2 13.9969 77.2 14.7333V20.2H79.2V14.7333C79.2 12.8924 77.7076 11.4 75.8667 11.4C73.5103 11.4 71.6 13.3102 71.6 15.6667Z",
    fill: "#0F0C18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6 11.6V20.8H73.6V11.6H71.6Z",
    fill: "#0F0C18"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6 11.6V12.4011V19.7989V20.8H95.6V11.6H93.6Z",
    fill: "#0F0C18"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2 15.6667V20.8H79.2V15.6667C79.2 14.4148 80.2148 13.4 81.4667 13.4C82.203 13.4 82.8 13.9969 82.8 14.7333V20.8H84.8V14.7333C84.8 12.8924 83.3076 11.4 81.4667 11.4C79.1102 11.4 77.2 13.3102 77.2 15.6667Z",
    fill: "#0F0C18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackfulllogo);
export default __webpack_public_path__ + "static/media/black full logo.cc87554a7859911fb97ebea39f81a0cb.svg";
export { ForwardRef as ReactComponent };